import FilterChip from "@/components/FilterChip"
import { useAppDispatch, useAppSelector } from "@/core/root-reducer"
import { difference, uniq } from "lodash"
import { RiskFamily } from "../model/risk-family.types"
import { faTriangleExclamation } from "@fortawesome/free-solid-svg-icons"
import physicalRiskStore from "@/entities/physical-risk/model/physical-risk.store"

interface Props {
  family: RiskFamily
  onReplace?: () => void
  riskIds: string[]
  showAdd?: boolean
  showRemove?: boolean
}

export default function RiskFamilyChip(props: Props) {
  const dispatch = useAppDispatch()
  const selectedRiskIds = useAppSelector(physicalRiskStore.selectors.selected)
  const riskMax = useAppSelector((state) => physicalRiskStore.selectors.maxForFamily(state, props.family.id))

  const isActive = props.riskIds.length > 0 && props.riskIds.every((id) => selectedRiskIds.includes(id))

  function handleClick() {
    if (isActive) {
      dispatch(physicalRiskStore.actions.select([]))
      return
    }

    props.onReplace?.()
    dispatch(physicalRiskStore.actions.select(props.riskIds))
  }

  function handleAddClick() {
    dispatch(physicalRiskStore.actions.select(uniq(selectedRiskIds.concat(props.riskIds))))
  }

  function handleRemoveClick() {
    dispatch(physicalRiskStore.actions.select(difference(selectedRiskIds, props.riskIds)))
  }

  return (
    <FilterChip
      icon={faTriangleExclamation}
      color={riskMax?.cValueEffectiveColor}
      isActive={isActive}
      name={props.family.name}
      onAddClick={props.showAdd !== false && !isActive ? handleAddClick : undefined}
      onClick={handleClick}
      onRemoveClick={props.showRemove && isActive ? handleRemoveClick : undefined}
    />
  )
}
